import {getOffset} from './_getOffset';
import skrollTop from 'skrollTop';

export function pageTop() {
  const pageTopButton = document.querySelectorAll('.js-page-top');
  if(pageTopButton) {
    for (let i = 0; i < pageTopButton.length; i++) {
      const el = pageTopButton[i];
      el.addEventListener('click', function(e) {
        e.preventDefault();
        const elOffset = getOffset(el);
        const elOffsetTop = elOffset.top;
        skrollTop.stop();
        document.body.classList.add('is-scrolling');
        skrollTop.scrollTo({
          to: 0,
          easing: window.easings.easeInOutQuint,
          duration: elOffsetTop*0.5,
          callback: () => { document.body.classList.remove('is-scrolling') }
        });
      });
    }
  }
  window.addEventListener('wheel', (e) => {
    skrollTop.stop();
    document.body.classList.remove('is-scrolling');
  });
  document.addEventListener('touchstart', (e) => {
    skrollTop.stop();
    document.body.classList.remove('is-scrolling');
  });
}